export default "__VITE_ASSET__37456248__"